<template>
  <footer class="footer">
    <p>版权所有 © 2000-2024 中软国际有限公司，保留一切权利&nbsp;&nbsp;&nbsp;<a href="http://www.chinasofti.com/ysbh/1648.htm">隐私保护</a>&nbsp;|
      <a href="http://www.chinasofti.com/flsm/1649.htm">法律声明</a> &nbsp;&nbsp;&nbsp;&nbsp; <a href="https://beian.miit.gov.cn">京ICP备05028939号-3</a>  &nbsp;&nbsp;&nbsp;&nbsp;京公安备11010802014778号</p>

  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #333;
  color: #999;
  text-align: center;
  padding: 1rem;
  margin-top: 2rem;
}
p{
  font-size: 14px;
  white-space: pre-wrap;
  color:#b2b4b7;
}
a{
  text-decoration: none;
  color:#b2b4b7;
}
</style>
